
  document.addEventListener('DOMContentLoaded', () => {
    // Handle ALL article share wrappers on the page
    document.querySelectorAll('.share-wrapper').forEach(wrapper => {
      const shareUrl = wrapper.dataset.shareUrl;
      const button = wrapper.querySelector('.share-data');
      const popup = wrapper.querySelector('.share-popup');
      const copyBtn = wrapper.querySelector('.share-popup__copy');
      const closeBtn = wrapper.querySelector('.share-popup__close');
      const messageEl = wrapper.querySelector('.share-popup__message');

      if (!button || !popup || !shareUrl) return;

      // Open share (native or popup)
      button.addEventListener('click', async (e) => {
        e.stopPropagation();

        // Try native Web Share API (mobile)
        if (navigator.share) {
          try {
            await navigator.share({ title: document.title, url: shareUrl });
            return;
          } catch (err) {
            // AbortError = user cancelled → ignore
            if (err.name !== 'AbortError') {
              console.warn('Web Share failed, falling back to popup');
            }
          }
        }

        // Fallback: show custom popup
        popup.classList.remove('hidden');
        // Optional: focus first interactive element
        copyBtn?.focus();
      });

      // Copy to clipboard
      copyBtn?.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(shareUrl);
          messageEl?.classList.remove('hidden');
          setTimeout(() => messageEl?.classList.add('hidden'), 2000);
        } catch (err) {
          console.error('Failed to copy:', err);
        }
      });

      // Close popup
      closeBtn?.addEventListener('click', () => {
        popup.classList.add('hidden');
      });
    });

    // Close any open popup when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.share-wrapper')) {
        document.querySelectorAll('.share-popup').forEach(popup => {
          popup.classList.add('hidden');
        });
      }
    });
  });